// Actions
import { TypedAction } from "@ms/uno-fluxcore/lib/local/actions/Action";
import { ActionType } from "../ActionType";
import { FailureAction } from "../FailureAction";
export class FetchModernGroupPhotosSucceededAction extends TypedAction(ActionType.FetchModernGroupPhotosSucceededAction) {
    constructor(modernGroupPhotos, statusMap){
        super(), this.modernGroupPhotos = modernGroupPhotos, this.statusMap = statusMap;
    }
}
export class FetchModernGroupAction extends TypedAction(ActionType.FetchModernGroupAction) {
    constructor(modernGroupId){
        super(), this.modernGroupId = modernGroupId;
    }
}
export class FetchModernGroupFailedAction extends FailureAction {
    constructor(modernGroupId, response, textStatus, errorThrown){
        super(ActionType.FetchModernGroupFailedAction, response, textStatus, errorThrown), this.modernGroupId = modernGroupId;
    }
}
export class FetchModernGroupSucceededAction extends TypedAction(ActionType.FetchModernGroupSucceededAction) {
    constructor(modernGroup, userId){
        super(), this.modernGroup = modernGroup, this.userId = userId;
    }
}
export class FetchUserJoinedModernGroupsAction extends TypedAction(ActionType.FetchUserJoinedModernGroupsAction) {
    constructor(userId){
        super(), this.userId = userId;
    }
}
export class FetchUserJoinedModernGroupsSucceededAction extends TypedAction(ActionType.FetchUserJoinedModernGroupsSucceededAction) {
    constructor(userId, joinedModernGroups, isFirstPage, nextLink){
        super(), this.userId = userId, this.joinedModernGroups = joinedModernGroups, this.isFirstPage = isFirstPage, this.nextLink = nextLink;
    }
}
export class FetchUserJoinedModernGroupsFailedAction extends FailureAction {
    constructor(userId, response, textStatus, errorThrown){
        super(ActionType.FetchUserJoinedModernGroupsFailedAction, response, textStatus, errorThrown), this.userId = userId;
    }
}
export class FetchModernGroupSiteUrlAndDriveIdAction extends TypedAction(ActionType.FetchModernGroupSiteUrlAndDriveIdAction) {
    constructor(modernGroupId){
        super(), this.modernGroupId = modernGroupId;
    }
}
export class FetchModernGroupSiteUrlAndDriveIdFailedAction extends FailureAction {
    constructor(modernGroupId, response, textStatus, errorThrown){
        super(ActionType.FetchModernGroupSiteUrlAndDriveIdFailedAction, response, textStatus, errorThrown), this.modernGroupId = modernGroupId;
    }
}
export class FetchModernGroupSiteUrlAndDriveIdSucceededAction extends TypedAction(ActionType.FetchModernGroupSiteUrlAndDriveIdSucceededAction) {
    constructor(modernGroupId, groupSiteUrlAndDriveId){
        super(), this.modernGroupId = modernGroupId, this.groupSiteUrlAndDriveId = groupSiteUrlAndDriveId;
    }
}
export class FetchOneDriveUrlForModernGroupAction extends TypedAction(ActionType.FetchOneDriveUrlForModernGroupAction) {
    constructor(modernGroupId){
        super(), this.modernGroupId = modernGroupId;
    }
}
export class FetchOneDriveUrlForModernGroupFailedAction extends FailureAction {
    constructor(modernGroupId, response, textStatus, errorThrown){
        super(ActionType.FetchOneDriveUrlForModernGroupFailedAction, response, textStatus, errorThrown), this.modernGroupId = modernGroupId;
    }
}
export class FetchOneDriveUrlForModernGroupSucceededAction extends TypedAction(ActionType.FetchOneDriveUrlForModernGroupSucceededAction) {
    constructor(modernGroupId, oneDriveUrl){
        super(), this.modernGroupId = modernGroupId, this.oneDriveUrl = oneDriveUrl;
    }
}
export class FetchModernGroupOwnersAction extends TypedAction(ActionType.FetchModernGroupOwnersAction) {
    constructor(modernGroupId){
        super(), this.modernGroupId = modernGroupId;
    }
}
export class FetchModernGroupOwnersFailedAction extends FailureAction {
    constructor(modernGroupId, response, textStatus, errorThrown){
        super(ActionType.FetchModernGroupOwnersFailedAction, response, textStatus, errorThrown), this.modernGroupId = modernGroupId;
    }
}
export class FetchModernGroupOwnersSucceededAction extends TypedAction(ActionType.FetchModernGroupOwnersSucceededAction) {
    constructor(modernGroupId, owners){
        super(), this.modernGroupId = modernGroupId, this.owners = owners;
    }
}
export class FetchModernGroupMembersSucceededAction extends TypedAction(ActionType.FetchModernGroupMembersSucceededAction) {
    loggingData() {
        return {
            ...super.loggingData(),
            modernGroupId: this.modernGroupId,
            memberCount: this.users.length.toString(),
            isFirstPage: this.isFirstPage.toString(),
            hasNextLink: (this.nextLink !== undefined).toString()
        };
    }
    constructor(modernGroupId, users, isFirstPage, nextLink){
        super(), this.modernGroupId = modernGroupId, this.users = users, this.isFirstPage = isFirstPage, this.nextLink = nextLink;
    }
}
export class FetchModernGroupMembersAction extends TypedAction(ActionType.FetchModernGroupMembersAction) {
    loggingData() {
        return {
            ...super.loggingData(),
            modernGroupId: this.modernGroupId
        };
    }
    constructor(modernGroupId){
        super(), this.modernGroupId = modernGroupId;
    }
}
export class FetchModernGroupMembersFailedAction extends TypedAction(ActionType.FetchModernGroupMembersFailedAction) {
    loggingData() {
        return {
            ...super.loggingData(),
            modernGroupId: this.modernGroupId,
            textStatus: this.textStatus,
            errorThrown: this.errorThrown
        };
    }
    constructor(modernGroupId, response, textStatus, errorThrown){
        super(), this.modernGroupId = modernGroupId, this.response = response, this.textStatus = textStatus, this.errorThrown = errorThrown;
    }
}
